module.exports = __webpack_public_path__ + "img/3_189.24260b0b.png";